import axios from 'axios'
import { showSpinner, hideSpinner } from './SpinnerActions'
import { getUsers, getLoggedInUser, deslectEwUser, filterUsers, selectEwUser } from '../../AcctMgt/action/userActions'
import { fetchEwCompanies, selectEwCompany } from '../../AcctMgt/action/ewCompanyActions'
import { fetchEwGroups } from '../../AcctMgt/action/ewGroupActions'

export const FETCH_FTPFOLDERS_BEGIN = "FETCH_FTPFOLDERS_BEGIN"
export const FETCH_FTPFOLDERS_SUCCESS = "FETCH_FTPFOLDERS_SUCCESS"
export const FETCH_FTPFOLDERS_FAILURE = "FETCH_FTPFOLDERS_FAILURE"

export const FETCH_USERFOLDERS_BEGIN = "FETCH_USERFOLDERS_BEGIN"
export const FETCH_USERFOLDERS_SUCCESS = "FETCH_USERFOLDERS_SUCCESS"
export const FETCH_USERFOLDERS_FAILURE = "FETCH_USERFOLDERS_FAILURE"

export const SET_AUTHFOLDERS = "SET_AUTHFOLDERS"
export const SAVE_USERFOLDERS_BEGIN = 'SAVE_USERFOLDERS_BEGIN'

export const SAVE_USERFOLDERS_SUCCESS = 'SAVE_USERFOLDERS_SUCCESS'

export const SAVE_USERFOLDERS_FAIL = 'SAVE_USERFOLDERS_FAIL'

export const CREATE_FOLDER_BEGIN = 'CREATE_FOLDER_BEGIN'
export const CREATE_FOLDER_SUCCESS = 'CREATE_FOLDER_SUCCESS'
export const CREATE_FOLDER_FAIL = 'CREATE_FOLDER_FAIL'

export const DELETE_FOLDER_BEGIN = 'DELETE_FOLDER_BEGIN'
export const DELETE_FOLDER_SUCCESS = 'DELETE_FOLDER_SUCCESS'
export const DELETE_FOLDER_FAIL = 'DELETE_FOLDER_FAIL'

export const TOGGLE_CREATE_FOLDER = 'TOGGLE_CREATE_FOLDER'

export const TOGGLE_DELETE_FOLDER = 'TOGGLE_DELETE_FOLDER'
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE'

export const SELECT_FOLDER = 'SELECT_FOLDER'
export const DESELECT_FOLDER = 'DESELECT_FOLDER'

function getFolders(publicCode) {
  return fetch(`/iframeApi/ftp/${publicCode}`)
    .then(handleErrors)
    .then(res => res.json());
}

async function getUserFolderTree(publicCode, input) {
  var result = await axios.post(`/iframeApi/ftp/${publicCode}`, input)
  return result.data
}

async function saveUserFolderTree(input) {
  var result = await axios.post(`/iframeApi/ftp/setFtp`, input)
  return result.data
}

async function createFolderTree(input) {
  var result = await axios.post(`/iframeApi/createDir`, input)
  return result.data
}
async function deleteFolderTree(input) {
  var result = await axios.post(`/iframeApi/deleteDir`, input)
  return result.data
}


const selFolder = folder => ({
  type: SELECT_FOLDER,
  payload: { folder }
})
const delSelFolder = () => ({
  type: DESELECT_FOLDER
})
const cMessage = () => ({
  type: CLEAR_MESSAGE
})
const toggleCFolder = () => ({
  type: TOGGLE_CREATE_FOLDER
})

const toggleDFolder = () => ({
  type: TOGGLE_DELETE_FOLDER
})

const createFolderBegin = () => ({
  type: CREATE_FOLDER_BEGIN
})

const createFolderSuccess = result => ({
  type: CREATE_FOLDER_SUCCESS,
  payload: { result }
})
const createFolderFail = error => ({
  type: CREATE_FOLDER_FAIL,
  payload: { error }
})

const deleteFolderBegin = () => ({
  type: DELETE_FOLDER_BEGIN
})

const deleteFolderSuccess = result => ({
  type: DELETE_FOLDER_SUCCESS,
  payload: { result }
})
const deleteFolderFail = error => ({
  type: DELETE_FOLDER_FAIL,
  payload: { error }
})

const saveUserFolderBegin = () => ({
  type: SAVE_USERFOLDERS_BEGIN
})

const saveUserFoldersSuccess = result => ({
  type: SAVE_USERFOLDERS_SUCCESS,
  payload: { result }
})

const saveUserFolderFail = error => ({
  type: SAVE_USERFOLDERS_FAIL,
  payload: { error }
})

const setAuthFoldersDo = node => ({
  type: SET_AUTHFOLDERS,
  payload: { node }
})



const fetchFtpFoldersBegin = () => ({
  type: FETCH_FTPFOLDERS_BEGIN
})

const fetchFtpFoldersSuccess = tree => ({
  type: FETCH_FTPFOLDERS_SUCCESS,
  payload: { tree }
})

const fetchFtpFoldersFail = error => ({
  type: FETCH_FTPFOLDERS_FAILURE,
  payload: { error }
})


const fetchUserFoldersBegin = () => ({
  type: FETCH_USERFOLDERS_BEGIN
})

const fetchUserFoldersSuccess = tree => ({
  type: FETCH_USERFOLDERS_SUCCESS,
  payload: { tree }
})

const fetchUserFoldersFail = error => ({
  type: FETCH_USERFOLDERS_FAILURE,
  payload: { error }
})

export function createFtpFolder(folder) {
  return dispatch => {
    dispatch(createFolderBegin());
    return createFolderTree(folder)
      .then(json => {
        dispatch(createFolderSuccess(json));
        return json;
      })
      .catch(error =>
        dispatch(createFolderFail(error))
      );
  };
}


export function deleteFtpFolder(folder) {
  return dispatch => {
    dispatch(deleteFolderBegin());
    return deleteFolderTree(folder)
      .then(json => {
        dispatch(deleteFolderSuccess(json));
        return json;
      })
      .catch(error =>
        dispatch(deleteFolderFail(error))
      );
  };
}


export function selectFolder(folder) {
  return selFolder(folder)
}

export function deselectFolder() {
  return delSelFolder()
}

export function clearMessage() {
  return cMessage()
}
export function toggleCreateFolder() {
  return toggleCFolder()
}

export function toggleDeleteFolder() {
  return toggleDFolder()
}

export function setAuthFolders(keys) {
  return setAuthFoldersDo(keys)
}

export function getFtpFolders(publicCode) {
  return dispatch => {
    dispatch(fetchFtpFoldersBegin());
    return getFolders(publicCode)
      .then(json => {
        dispatch(fetchFtpFoldersSuccess(json));
        return json;
      })
      .catch(error =>
        dispatch(fetchFtpFoldersFail(error))
      );
  };
}

export function getUserFolders(publicCode, folders) {
  return dispatch => {
    dispatch(fetchUserFoldersBegin());
    return getUserFolderTree(publicCode, folders)
      .then(json => {
        dispatch(fetchUserFoldersSuccess(json));
        return json;
      })
      .catch(error =>
        dispatch(fetchUserFoldersFail(error))
      );
  };
}


export function saveUserFolders(input, users) {
  return dispatch => {
    dispatch(saveUserFolderBegin());
    return saveUserFolderTree(input)
      .then(json => {
        dispatch(filterUsers({ context: input.publicCode, allUsers: users }))
          .then(s => {
            dispatch(saveUserFoldersSuccess(json));
            return json;
          })

      })
      .catch(error =>
        dispatch(saveUserFolderFail(error))
      );
  };
}

export function initializePage() {
  return dispatch => {
    dispatch(showSpinner('Fetching Users'))
    dispatch(getUsers())
      .then((users) => {
        dispatch(showSpinner('Fetching Groups'))
        dispatch(fetchEwGroups())
          .then(() => {
            dispatch(showSpinner('Fetching Accounts'))
            dispatch(fetchEwCompanies())
              .then((c) => {
                dispatch(showSpinner('Fetching Current User Info'))
                dispatch(getLoggedInUser())
                  .then(u => {
                    console.log('info', c, u)
                    if (!u.idea) {
                      let co = c.Mfrs.find(m => {
                        return m['Public Id of Manufacturer'] == u.securityContextValue
                      })
                      if (!co) {
                        co = c.Dists.find(m => {
                          return m['Public Id of Distributor'] == u.securityContextValue
                        })
                      }
                      if (co) {
                        dispatch(selectEwCompany(co))
                        dispatch(deslectEwUser())
                        console.log()
                        dispatch(getUserFolders(co['Public Id of Distributor'] ?
                          co['Public Id of Distributor'] :
                          co['Public Id of Manufacturer'], null))
                        dispatch(filterUsers({
                          context: co['Public Id of Manufacturer'] ?
                            co['Public Id of Manufacturer']
                            : co['Public Id of Distributor'], allUsers: users
                        }))
                          .then((f) => {
                            if (f.length > 0) {
                              dispatch(hideSpinner())
                              /*     let g = f[0]
                                  dispatch(selectEwUser(g))
                                  dispatch(getUserFolders(co['Public Id of Distributor'] ?
                                  co['Public Id of Distributor'] :
                                  co['Public Id of Manufacturer']  , g['FTP']))
                                  .then(()=>{
                                    dispatch(hideSpinner())
                                  }) */
                            }
                            else
                              dispatch(hideSpinner())
                          })

                      }
                    }
                    else {
                      dispatch(hideSpinner())
                    }


                  })

              })
          })
      })


  }

  //await 
}

function handleErrors(response) {
  console.log('habdle herror', response)
  if (response.statusText !== 'OK') {
    throw Error(response.statusText);
  }
  return response;
}